import type { ReactNode } from 'react';
import SiteNavbar from '@/components/feature/SiteNavbar';
import SiteFooter from '@/components/feature/SiteFooter';
import BackToTop from '@/components/feature/BackToTop';
import ScrollManager from '@/components/feature/ScrollManager';

interface SiteLayoutProps {
  children: ReactNode;
}

export default function SiteLayout({ children }: SiteLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <ScrollManager />
      <SiteNavbar />
      <main className="flex-1 w-full">{children}</main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}